import {
  OverlayRef,
  OverlaySizeConfig,
  Overlay
} from '@angular/cdk/overlay';
import { Injector } from '@angular/core';

export class WindowRef {
  constructor(public overlayRef: OverlayRef, private overlay: Overlay) {}

  public close(): void {
    this.overlayRef.detach();
  }

  public minimize(): void {
    this.overlayRef.hostElement.style.display = 'none';
  }

  public reopen(): void {
    this.overlayRef.hostElement.style.display = 'flex';
  }

  public getSizeConfig(): OverlaySizeConfig {
    const config = this.overlayRef.getConfig();
    return {
      width: config.width,
      height: config.height,
      minHeight: config.minHeight,
      minWidth: config.minWidth,
      maxHeight: config.maxHeight,
      maxWidth: config.maxWidth,
    }
  }

  public setWidth(width: string): void {
    this.overlayRef.updateSize({
      ...this.getSizeConfig(),
      width
    })
  }

  public setHeight(height: string): void {
    this.overlayRef.updateSize({
      ...this.getSizeConfig(),
      height
    })
  }

  public setPos(x: string, y: string): void {
    this.overlayRef.updatePositionStrategy(this
      .overlay
      .position()
      .global()
      .top(y)
      .left(x)
    );
    this.overlayRef.updatePosition();
  }

}
